export default function EmptyIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="147"
            height="95"
            fill="none"
            viewBox="0 0 147 95"
        >
            <path
                stroke="#BFEAFF"
                strokeMiterlimit="10"
                strokeWidth="1.941"
                d="M18.297 11.56h104.511M116.454 86.601H24.682c-3.537 0-6.385-2.769-6.385-6.208V7.482c0-3.439 2.848-6.208 6.385-6.208h91.772c3.537 0 6.385 2.77 6.385 6.208v72.911c-.031 3.439-2.88 6.208-6.385 6.208z"
            ></path>
            <path
                stroke="#BFEAFF"
                strokeMiterlimit="10"
                strokeWidth="1.941"
                d="M28.626 6.538c0 .791-.658 1.43-1.471 1.43-.814 0-1.471-.639-1.471-1.43 0-.791.657-1.43 1.47-1.43.814-.03 1.472.639 1.472 1.43zM34.354 6.539c0 .79-.657 1.43-1.47 1.43-.815 0-1.472-.64-1.472-1.43 0-.792.657-1.43 1.471-1.43.814 0 1.471.638 1.471 1.43zM40.085 6.538c0 .791-.657 1.43-1.471 1.43-.814 0-1.471-.639-1.471-1.43 0-.791.657-1.43 1.47-1.43.783-.03 1.472.639 1.472 1.43z"
            ></path>
            <path
                fill="#F3F4F5"
                d="M67.814 92.809c15.4-1.613 64.384 2.343 60.378-5.021-.626-1.096-3.85-2.556-1.189-3.682 1.909-.852 5.477-1.4 8.92-1.826 8.983-1.096 12.301-2.77 9.954-4.9-6.229-5.781-39.345-3.316-56.716-1.004-12.364 1.704-26.95 2.404-39.782 1.674-10.048-.578-16.37-2.282-28.14-1.37-10.453.792-11.956 3.074-8.857 5.052 1.753 1.217 3.036 1.734-.407 3.073-2.88 1.309-7.95 2.404-8.326 3.865-.062 1.552 3.162 3.043 9.328 3.439 5.039.335 9.609 0 14.585.122 11.08.365 18.28 4.016 31.99 2.251 3.41-.456 5.32-1.369 9.045-1.734"
            ></path>
            <path
                fill="#A3A8AF"
                d="M123.309 82.22c5.603 0 10.141-.487 10.141-1.126 0-.64-4.538-1.126-10.141-1.126s-10.141.487-10.141 1.126c0 .639 4.538 1.126 10.141 1.126z"
                opacity="0.5"
            ></path>
            <path
                fill="url(#paint0_linear)"
                d="M134.577 63.596c-.375-2.1-1.439-3.956-2.191-5.934-.939-2.557-.5-4.596.188-7.121 1.033-3.804 1.064-8.064-.97-11.564-.563-.943-1.315-1.795-1.847-2.739-.626-1.034-.876-2.404-1.033-3.59-.125-1.126.094-2.283.032-3.409a15.756 15.756 0 00-.47-2.92c-.72-2.648-2.692-6.087-5.978-6.057-3.881.03-4.852 4.565-4.726 7.517.093 2.039.438 4.23-.313 6.208-.814 2.13-2.974 3.438-4.195 5.325-1.815 2.77-2.191 6.39-.907 9.464.72 1.734 2.285 3.286 2.347 5.203.063 2.252-2.473 3.56-3.599 5.235-1.941 2.8-2.035 6.45-.689 9.524 3.349 6.817 12.614 9.22 19.187 5.386.094 0 .219 0 .313-.06 3.318-2.496 5.571-6.33 4.851-10.468z"
            ></path>
            <path
                fill="#49A6D6"
                d="M122.589 80.759c.063-3.287.094-6.603.157-9.89a32.83 32.83 0 01-5.165-7.364c-.187-.365.407-.578.595-.213a29.897 29.897 0 004.601 6.695l.094-8.369c-.031 0-.062-.03-.062-.06-2.129-2.283-3.913-4.809-5.415-7.547-.188-.335.407-.579.563-.214a37.465 37.465 0 004.914 6.939l.094-7.851a37.825 37.825 0 01-3.756-5.356c-.188-.335.313-.7.501-.365a38.955 38.955 0 003.255 4.747c.031-2.617.063-5.204.063-7.82-.032-.031-.063-.031-.094-.092a39.44 39.44 0 01-2.661-3.348c-.219-.304.251-.7.501-.365a34.745 34.745 0 002.285 2.891c0-1.734.031-3.5.031-5.234 0-.395.626-.456.626-.06 0 2.403-.031 4.807-.062 7.242a45.276 45.276 0 012.097-3.287c.219-.334.72.061.501.365-.939 1.34-1.784 2.74-2.598 4.17-.032 2.13-.032 4.26-.063 6.36v.06c0 1.187-.031 2.374-.031 3.56a34.758 34.758 0 004.726-6.481c.188-.335.751-.091.563.243a36.331 36.331 0 01-5.321 7.151c-.031 3.013-.062 6.056-.125 9.069 1.471-1.552 2.974-3.074 4.445-4.626.282-.274.782.092.501.366a759.511 759.511 0 00-4.946 5.142 1928.13 1928.13 0 01-.219 13.603c.032.395-.595.304-.595-.061z"
            ></path>
            <path
                fill="url(#paint1_linear)"
                d="M28.187 62.288c-.313-1.765-1.22-3.348-1.847-5.021-.813-2.161-.407-3.896.157-6.026.876-3.225.908-6.816-.814-9.768-.47-.791-1.095-1.491-1.565-2.313-.532-.882-.751-2.038-.876-3.043-.094-.943.094-1.917.031-2.89a9.663 9.663 0 00-.407-2.465c-.626-2.252-2.285-5.143-5.04-5.113-3.254.03-4.1 3.865-4.006 6.36.063 1.735.376 3.59-.25 5.234-.689 1.826-2.504 2.891-3.537 4.504-1.534 2.343-1.847 5.417-.782 8.003.594 1.46 1.909 2.77 1.972 4.413.062 1.886-2.066 3.012-3.068 4.412-1.628 2.374-1.721 5.477-.595 8.064 2.849 5.782 10.674 7.79 16.214 4.534.094.03.188 0 .25-.06 2.848-2.1 4.758-5.356 4.163-8.825z"
            ></path>
            <path
                fill="#49A6D6"
                d="M18.047 76.772c.031-2.8.094-5.569.125-8.368-1.753-1.887-3.224-3.956-4.35-6.238-.157-.305.344-.487.5-.183a26.177 26.177 0 003.881 5.66l.094-7.09c-.031 0-.031-.03-.063-.061-1.815-1.948-3.317-4.078-4.6-6.39-.157-.305.344-.487.5-.183a30.065 30.065 0 004.163 5.873c.031-2.221.063-4.443.063-6.634a35.122 35.122 0 01-3.193-4.534c-.156-.274.25-.609.407-.304.814 1.4 1.753 2.739 2.754 4.047.032-2.221.032-4.412.063-6.634-.031 0-.063-.03-.094-.06a32.13 32.13 0 01-2.253-2.83c-.188-.275.219-.579.406-.305a37.785 37.785 0 001.941 2.465c0-1.491.031-2.952.031-4.443 0-.335.532-.396.532-.06 0 2.038-.03 4.077-.062 6.116.563-.944 1.127-1.887 1.753-2.8.187-.274.594.03.407.304a51.463 51.463 0 00-2.192 3.53c-.03 1.796-.03 3.591-.062 5.386v.061c0 1.005-.031 2.009-.031 3.013 1.533-1.674 2.91-3.5 4.006-5.508.157-.304.657-.06.47.213a30.765 30.765 0 01-4.508 6.056l-.094 7.699 3.756-3.926c.22-.243.658.06.407.304-1.408 1.461-2.785 2.922-4.194 4.352l-.188 11.533c.157.335-.375.274-.375-.06z"
            ></path>
            <path
                fill="#A3A8AF"
                d="M72.078 87.14c13.31 0 24.1-.736 24.1-1.643 0-.908-10.79-1.644-24.1-1.644-13.311 0-24.101.736-24.101 1.644 0 .907 10.79 1.643 24.1 1.643z"
                opacity="0.3"
            ></path>
            <g opacity="0.8">
                <path
                    fill="#CBCFD3"
                    d="M72.01 46.4s-.25-2.782.788-3.93c1.073-1.147 2.897-1.947 3.863-1.217.966.73 2.075 3.965 2.003 4.452-.035.487-6.653.695-6.653.695z"
                    opacity="0.5"
                ></path>
                <path
                    fill="#747C87"
                    d="M71.152 45.705l1.073 12.971 8.693-.869-1.324-12.937-8.442.835z"
                    opacity="0.5"
                ></path>
                <g fill="#747C87" opacity="0.5">
                    <path
                        d="M66.147 41.011s5.902-14.467 11.196-14.293c0 0 2.289.73-.108 2.956-2.432 2.26-11.088 11.337-11.088 11.337zM66.432 41.29s9.622-7.443 11.768-5.843c0 0 1.216.765-.215 1.426-1.43.66-7.01 1.53-11.553 4.416zM65.682 40.315c.071-.07 3.612-8.068 2.217-8.103-1.395-.07-2.217 8.103-2.217 8.103z"
                        opacity="0.5"
                    ></path>
                    <path
                        d="M58.848 45.915c.035-.14 6.08-7.512 6.08-7.512s1.932 0 2.326 1.113c.393 1.113 1.574.765 2.11 1.286l-7.333 8.312-3.183-3.2z"
                        opacity="0.5"
                    ></path>
                </g>
                <g opacity="0.5">
                    <g fill="#CBCFD3" opacity="0.5">
                        <path
                            d="M83.886 60.033l-3.291-.418a1.1 1.1 0 01-.966-1.217l1.144-8.45c.072-.592.644-1.009 1.252-.94l3.291.418a1.1 1.1 0 01.966 1.217l-1.144 8.45c-.072.592-.644 1.01-1.252.94z"
                            opacity="0.5"
                        ></path>
                        <path
                            d="M84.029 51.373L82.74 51.2c-.25-.035-.393-.244-.393-.487l.429-3.304c.036-.243.25-.383.5-.383l1.288.174c.25.035.394.244.394.487l-.43 3.304a.442.442 0 01-.5.383z"
                            opacity="0.5"
                        ></path>
                    </g>
                    <path
                        fill="#747C87"
                        d="M85.27 51.002l-3.582-.455-.719 5.345 3.583.455.718-5.345z"
                        opacity="0.5"
                    ></path>
                </g>
                <g opacity="0.5">
                    <g opacity="0.5">
                        <path
                            fill="#CBCFD3"
                            d="M78.734 59.268l-4.615-.244c-.286 0-.536-.278-.5-.556l.071-1.426c0-.278.286-.522.573-.487l4.614.243c.286 0 .537.279.5.557l-.07 1.426c-.037.278-.287.522-.573.487z"
                            opacity="0.5"
                        ></path>
                        <path
                            fill="#A3A8AF"
                            d="M77.376 57.181l-1.718-.104c-.107 0-.214-.104-.178-.209l.035-.521c0-.105.108-.209.215-.174l1.717.104c.107 0 .215.105.179.209l-.036.522c0 .104-.071.208-.215.173z"
                            opacity="0.5"
                        ></path>
                    </g>
                    <path
                        fill="#747C87"
                        d="M79.366 57.538l-5.716-.294-.056 1.041 5.715.295.057-1.042z"
                        opacity="0.5"
                    ></path>
                </g>
                <path
                    fill="#CBCFD3"
                    d="M57.999 30.967l-16.116 4.406 6.371 22.03 16.116-4.407L58 30.966z"
                    opacity="0.5"
                ></path>
                <path
                    fill="#CBCFD3"
                    d="M71.392 47.183l-9.646-.453-.57 11.462 9.646.454.57-11.463zM60.752 55.727l-6.467-.304-.11 2.223 6.466.304.11-2.223z"
                    opacity="0.5"
                ></path>
                <path
                    fill="#747C87"
                    d="M92.22 74.848c-2.683 0-4.864 2.121-4.864 4.73 0 2.608 2.181 4.73 4.864 4.73s4.865-2.122 4.865-4.73c0-2.643-2.182-4.73-4.865-4.73z"
                    opacity="0.5"
                ></path>
                <path
                    fill="#4F5459"
                    d="M92.22 77.387c-1.252 0-2.253.974-2.253 2.19 0 1.218 1.001 2.192 2.253 2.192 1.252 0 2.254-.974 2.254-2.191 0-1.218-1.002-2.191-2.254-2.191z"
                    opacity="0.5"
                ></path>
                <path
                    fill="#747C87"
                    d="M53.445 74.848c-2.683 0-4.865 2.121-4.865 4.73 0 2.608 2.182 4.73 4.865 4.73 2.683 0 4.865-2.122 4.865-4.73 0-2.643-2.182-4.73-4.865-4.73z"
                    opacity="0.5"
                ></path>
                <path
                    fill="#4F5459"
                    d="M53.445 77.387c-1.252 0-2.254.974-2.254 2.19 0 1.218 1.002 2.192 2.254 2.192s2.254-.974 2.254-2.191c0-1.218-1.002-2.191-2.254-2.191z"
                    opacity="0.5"
                ></path>
                <path
                    fill="#A3A8AF"
                    d="M101.913 24.526c-.286-.279-.751-.313-1.037-.035l-6.224 5.599c-.108.07-.144.174-.215.313l-.787 2.4-52.225 2.4c-.179 0-.358.103-.5.243a.565.565 0 00-.18.521L41.82 57.32c.035.348.322.661.68.661l42.888 3.026h.036c.322 0 .608-.209.68-.487l8.763-26.813v-.035l.894-2.678 6.081-5.495c.322-.243.322-.695.072-.973zM87.319 52.208l-4.794-.174 2.004-7.86 5.437-.034-2.647 8.068zM81.238 52l-5.402-.208 1.825-7.547 5.58-.035L81.238 52zm-7.119 6.817l1.395-5.808 5.366.209-1.538 5.981-5.223-.382zm-6.224-.452l1.073-5.6 5.259.21-1.395 5.772-4.937-.382zm-6.868-.487l.823-5.39 5.83.208-1.073 5.564-5.58-.382zm-5.723-.383l.393-5.216 4.901.174-.823 5.355-4.471-.313zm-6.975-.487l.322-4.973 5.759.209-.394 5.182-5.687-.418zM42.64 44.522l5.259-.034-.43 6.26-4.543-.174-.286-6.052zm6.546-.07l5.867-.034-.501 6.573-5.76-.209.394-6.33zm6.51-8.45l-.572 7.199-5.866.035.465-6.956 5.974-.278zm7.512-.348l-1.18 7.477-5.652.035.572-7.233 6.26-.279zm7.834-.382l-1.502 7.79-6.224.035 1.18-7.547 6.546-.278zm7.548-.348l-1.932 8.068-5.83.035 1.502-7.825 6.26-.278zm-15.453 9.425l6.152-.035-1.359 7.199-5.866-.21 1.073-6.954zm-2.361 6.885l-5.008-.174.5-6.642 5.545-.035-1.037 6.851zm9.801-6.955l5.76-.035-1.825 7.512-5.33-.209 1.395-7.268zm7.369-1.287l1.967-8.138 5.76-.278-2.111 8.347-5.616.07zm-29.475-6.677l-.465 6.92-5.401.035-.322-6.677 6.188-.278zm-5.473 15.476l4.4.174-.322 4.938-3.828-.278L43 51.79zm41.923 7.79l-4.22-.313 1.537-6.017 4.722.174-2.039 6.156zm5.437-16.693l-5.544.035 2.146-8.382 6.224-.278-2.826 8.625z"
                    opacity="0.5"
                ></path>
                <path
                    fill="#4F5459"
                    d="M99.265 27.76c-.25 0-.5-.104-.644-.278a.856.856 0 01.072-1.217l3.183-2.713a.916.916 0 011.252.07.856.856 0 01-.071 1.217l-3.184 2.713c-.215.139-.393.209-.608.209zM42.535 58.155c-.465 0-.858-.348-.858-.8l-1.073-21.353c-.036-.452.358-.87.822-.904.501-.035.895.348.93.8L43.43 57.25c.035.452-.358.87-.823.904h-.072z"
                    opacity="0.5"
                ></path>
                <path
                    fill="#A3A8AF"
                    d="M92.364 79.23l-.966-5.738c.394-.035.68-.313.68-.696v-7.755a.81.81 0 00-.25-.556l-5.938-4.73c-.322-.244-.787-.209-1.038.104-.25.313-.214.765.108 1.009l5.651 4.52v6.713l-41.78.73-1.359-3.686c-.143-.383-.536-.557-.93-.418-.393.14-.572.522-.43.905l1.289 3.512-5.616 2.121c-.358.14-.573.557-.43.905a.734.734 0 00.68.452c.072 0 .179 0 .25-.035l6.117-2.33h.859l3.934 5.495c.215.278.573.104.573-.278l-.25-5.252 33.409-.591 4.936 5.877c.25.174.573 0 .501-.278z"
                    opacity="0.5"
                ></path>
            </g>
            <defs>
                <linearGradient
                    id="paint0_linear"
                    x1="121.145"
                    x2="123.808"
                    y1="40.654"
                    y2="116.735"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#8FD8FC"></stop>
                    <stop offset="1" stopColor="#8FD8FC" stopOpacity="0"></stop>
                </linearGradient>
                <linearGradient
                    id="paint1_linear"
                    x1="17.571"
                    x2="17.571"
                    y1="56.383"
                    y2="112.984"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#BFEAFF"></stop>
                    <stop offset="1" stopColor="#BFEAFF" stopOpacity="0"></stop>
                </linearGradient>
            </defs>
        </svg>
    );
}